import React, { useState } from 'react';

import classNames from 'classnames';
import { dispatch } from 'redux/store';
import { finalize } from 'rxjs/operators';
import { useSelector } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

import Button from 'components/CustomButtons/Button';
import { BodyMBold, DescriptionM } from 'components/Typography/Typography';

import PaymentService from 'services/payments/payment';
import { setToast } from 'redux/modules/toast/actions';
import { getPaymentMethodLabels } from 'redux/modules/dynamicLabels/selectors';

import { PayWith } from 'components/PaymentMethod/type';
import { translate } from 'components/Translation';
import { usePaymentMethod } from 'components/PaymentMethod/context';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/paymentMethodsStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

const DeleteCardConfirmation = () => {
	const classes = useStyles();
	const paymentMethodLabels = useSelector(getPaymentMethodLabels);

	const { deleteTokenPayload, closeDeleteModal, refreshTokens, onDeleteToken } = usePaymentMethod();

	const [deleteTokenInProgress, setDeleteTokenInProgress] = useState<boolean>();

	const onDeleteHandle = () => {
		if (deleteTokenPayload?.isUnsaved) {
			onDeleteToken();
			return;
		}

		setDeleteTokenInProgress(true);
		PaymentService.deletePaymentToken(
			deleteTokenPayload?.tokenType as string,
			deleteTokenPayload?.tokenID as string
		)
			.pipe(
				finalize(() => {
					refreshTokens();
					setDeleteTokenInProgress(false);
					closeDeleteModal();
				})
			)
			.subscribe(
				() => {
					const _tokenType = deleteTokenPayload?.tokenType?.toLowerCase();
					dispatch(
						setToast({
							error: false,
							label: translate(`wallet.${_tokenType}.deleted`),
						})
					);
				},
				() => dispatch(setToast({ error: true, label: 'error' }))
			);
	};

	const confirmationMessage = {
		[PayWith.CARD]: paymentMethodLabels?.confirmation_info_card,
		[PayWith.BM]: paymentMethodLabels?.confirmation_info_bm,
	};

	return (
		<Dialog aria-labelledby="customized-dialog-title" open={!!deleteTokenPayload}>
			<MuiDialogTitle disableTypography>
				<BodyMBold customClassName={classes.marginBottomNone}>{paymentMethodLabels?.confirmation}</BodyMBold>
				<IconButton
					aria-label="close"
					disabled={deleteTokenInProgress}
					className={classes.closeButton}
					onClick={closeDeleteModal}
				>
					<CloseIcon />
				</IconButton>
			</MuiDialogTitle>
			<MuiDialogContent dividers className={classes.addCardDialog}>
				<div className={classes.billDetailsContainer}>
					<DescriptionM>{confirmationMessage[deleteTokenPayload?.tokenType ?? PayWith.CARD]}</DescriptionM>
				</div>
				<div className={classNames(classes.billDetailsContainer, classes.addCardDialogFooter)}>
					<Button color="secondary-light" disabled={deleteTokenInProgress} onClick={closeDeleteModal}>
						{paymentMethodLabels.cancel}
					</Button>
					<Button
						type="submit"
						color="primary-light"
						disabled={deleteTokenInProgress}
						onClick={onDeleteHandle}
					>
						{paymentMethodLabels.delete}
					</Button>
				</div>
			</MuiDialogContent>
		</Dialog>
	);
};

export default DeleteCardConfirmation;
